// extracted by mini-css-extract-plugin
module.exports = {"root":"Settings_root__3nWPc","search":"Settings_search__3sUK3","filter":"Settings_filter__3Ko7d"};